module.exports = __webpack_public_path__ + "static/15-681f3cf3334c38460e6e37bba3bbb74a.png";